import React, { useEffect, useState, useContext } from "react";
import Photocontainer from "./Photocontainer";
import MyContext from "../../../../context/MyContext";
import Lottie from "react-lottie";
import loader from "../../../../assets/Loader/AssetLoader.json";

export const PixabayPics = () => {
  const { ImageData, setImageData, setisTextInputOrAreaFocus } =
    useContext(MyContext);
  const [MyLoader, setMyLoader] = useState(false);
  const [DefaultImages, setDefaultImages] = useState(null);

  useEffect(() => {
    if (ImageData.apiData.length === 0) {
      setMyLoader(true);
      fetch(
        `https://pixabay.com/api/?key=4581280-63c91ad658c69ede7692de09e&q= &pretty=true&per_page=200&safesearch=true`
      ).then((response) => {
        if (!response.ok) {
          throw Error("not working");
        }
        return response
          .json()
          .then((allData) => {
            setImageData({ ...ImageData, apiData: allData.hits });
            setMyLoader(false);
            setDefaultImages(true);
          })
          .catch((err) => {
            setMyLoader(false);
            throw Error(err.message);
          });
      });
    }
  }, []);

  function isEmptyOrSpaces(str) {
    return str === null || str.match(/^ *$/) !== null;
  }

  const handlechange = (e) => {
    if (e.key === "Enter") {
      if (!isEmptyOrSpaces(e.target.value)) {
        setMyLoader(true);
        fetch(
          `https://pixabay.com/api/?key=4581280-63c91ad658c69ede7692de09e&q=${e.target.value}&pretty=true&per_page=200&safesearch=true`
        ).then((response) => {
          if (!response.ok) {
            throw Error("not working");
          }
          return response
            .json()
            .then((allData) => {
              setImageData({ ...ImageData, apiData: allData.hits });
              setMyLoader(false);
              setDefaultImages(false);
            })
            .catch((err) => {
              setMyLoader(false);
              throw Error(err.message);
            });
        });
      } else {
        if (!DefaultImages) {
          setMyLoader(true);
          fetch(
            `https://pixabay.com/api/?key=4581280-63c91ad658c69ede7692de09e&q=${e.target.value}&pretty=true&per_page=200&safesearch=true`
          ).then((response) => {
            if (!response.ok) {
              throw Error("not working");
            }
            return response
              .json()
              .then((allData) => {
                setImageData({ ...ImageData, apiData: allData.hits });
                setMyLoader(false);
                setDefaultImages(true);
              })
              .catch((err) => {
                setMyLoader(false);
                throw Error(err.message);
              });
          });
        }
      }
    }
  };

  return (
    <div style={{ height: "100%" }}>
      <div className="searchBarParent" style={{ padding: "0px 12px" }}>
        <span className="material-icons SearchIconCustom">search</span>
        <input
          className="search customInput searchpad mb-1"
          type="search"
          placeholder="Search Photos..."
          onKeyDown={handlechange}
          onFocus={() => setisTextInputOrAreaFocus(true)}
          onBlur={() => setisTextInputOrAreaFocus(false)}
        />
      </div>
      {!MyLoader && ImageData.apiData != null && (
        <Photocontainer
          isUserImage={"false"}
          Pic={ImageData.apiData}
          type={"Images"}
        />
      )}

      {MyLoader == true && (
        <Lottie
          options={{ loop: true, autoplay: true, animationData: loader }}
          height={200}
          width={200}
          isStopped={false}
          isPaused={false}
        />
      )}
    </div>
  );
};
export default PixabayPics;
